module.exports = __webpack_public_path__ + "static/media/MyPathMainNav.8784479c.jpg";